import { getSyncDefaultSearch } from '../../helpers/Common';
import reducerRegistry from '../../helpers/ReducerRegistry';
import priceDataService from './../../../core/services/Prices/PriceData/PriceDataService';
import ownerShipService from '../../../core/services/Fundamental/OwnerShip';
import snapShotService from '../../../core/services/Fundamental/SnapShotService';
import ConstCommon from './../../common/Const';
import currentState from './../../helpers/CurrentState';

const REDUCER_NAME = 'OWNER_SHIP:';
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;
const CHANGE_CODE = `${REDUCER_NAME}CHANGE_CODE`;
const SUBSCRIBE_REALTIME_DATA_TICK = `${REDUCER_NAME}SUBSCRIBE_REALTIME_DATA_TICK`;
const FETCH_INFO_TICKER = `${REDUCER_NAME}FETCH_INFO_TICKER`;
const FETCH_LIST_DATA_OWNERSHIP = `${REDUCER_NAME}FETCH_LIST_DATA_OWNERSHIP`;
const FETCH_SHARE_HOLDER_TOOLTIP = `${REDUCER_NAME}FETCH_SHARE_HOLDER_TOOLTIP`;
const FETCH_BOD_TOOLTIP = `${REDUCER_NAME}FETCH_BOD_TOOLTIP`;
const GET_COMPANY_SCORE = `${REDUCER_NAME}GET_COMPANY_SCORE`;

export {
  REDUCER_NAME,
  reducer as default,
  changeCode,
  subscribeRealtimeTick,
  fetchInfoTicker,
  fetchListDataOwnership,
  fetchInfoBoDTooltip,
  fetchInfoShareHolderTooltip,
  fetchCompanyScore,
};

//realtime
function subscribeRealtimeTick(data, id) {
  return {
    type: SUBSCRIBE_REALTIME_DATA_TICK,
    payload: {
      result: data,
      id,
    },
  };
}

function changeCode(currentSearch, id) {
  return dispatch => {
    dispatch({
      type: CHANGE_CODE,
      payload: {
        currentSearch,
        conditionId: id,
      },
    });
    dispatch(fetchInfoTicker(id));
    dispatch(fetchListDataOwnership(id));
    dispatch(fetchCompanyScore(id));
  };
}

function fetchInfoTicker(id) {
  return (dispatch, getState) => {
    const currentSearch = getState()[REDUCER_NAME].listMultiComponent[id]
      .currentSearch;
    const code = currentSearch.code;
    priceDataService.getLatestPrice({ Code: code }).then(response => {
      let tickerInfomation = {};
      if (response.items) {
        tickerInfomation = response.items[0];
      }

      dispatch({
        type: FETCH_INFO_TICKER,
        payload: {
          infoTicker: tickerInfomation,
          inforTickerId: id,
        },
      });
    });
  };
}

function fetchCompanyScore(id) {
  return (dispatch, getState) => {
    const code = getState()[REDUCER_NAME].listMultiComponent[id].currentSearch
      .code;
    snapShotService.getCompanyScore({ OrganCode: code }).then(response => {
      const { items = [] } = response;
      dispatch({
        type: GET_COMPANY_SCORE,
        payload: {
          companyScore: items && items[0] ? items[0] : {},
          companyScroreId: id,
        },
      });
    });
  };
}

function fetchListDataOwnership(id) {
  return (dispatch, getState) => {
    const code = getState()[REDUCER_NAME].listMultiComponent[id].currentSearch
      .code;
    ownerShipService.getOwnerShipData({ OrganCode: code }).then(response => {
      dispatch({
        type: FETCH_LIST_DATA_OWNERSHIP,
        payload: {
          response,
          componentId: id,
        },
      });
    });
  };
}

function fetchInfoShareHolderTooltip(code, id, listOrganizationByOrganCode) {
  return dispatch => {
    return ownerShipService
      .getInfoShareHolderTooltip({ Code: code })
      .then(response => {
        dispatch({
          type: FETCH_SHARE_HOLDER_TOOLTIP,
          payload: {
            code,
            shareHolderTooltipInfo: response,
            infoShareHolderTooltipId: id,
            listOrganizationByOrganCode,
          },
        });
        return true;
      });
  };
}

function fetchInfoBoDTooltip(code, personId, componentId) {
  return dispatch => {
    ownerShipService
      .getInfoBoDTooltip({ OrganCode: code, PersonId: personId })
      .then(response => {
        dispatch({
          type: FETCH_BOD_TOOLTIP,
          payload: {
            code,
            personId,
            bodTooltipInfo: response,
            infoBodTooltipId: componentId,
          },
        });
      });
  };
}

const initialState = {
  listMultiComponent: {},
};

const appendId = (data, indexListAppend) => {
  if (!data) {
    return [];
  }

  if (indexListAppend && indexListAppend.length !== 0) {
    const { list, ids } = data.reduce(
      (result, item, index) => {
        indexListAppend += 1;
        return {
          ids: result.ids.concat(indexListAppend),
          list: {
            ...result.list,
            [indexListAppend]: item,
          },
        };
      },
      { list: {}, ids: [] },
    );
    return [list, ids];
  } else {
    const { list, ids } = data.reduce(
      (result, item, index) => {
        return {
          ids: result.ids.concat(index + 1),
          list: {
            ...result.list,
            [index + 1]: item,
          },
        };
      },
      { list: {}, ids: [] },
    );
    return [list, ids];
  }
};

function transformExchangeTicker(codeName, exchange) {
  return codeName + ' / ' + exchange;
}

function reducer(state = {}, action) {
  switch (action.type) {
    case INIT_COMPONENT:
      const dataId = action.payload.id;
      const { dragCode } = action.payload;

      return {
        ...state,
        ...initialState,
        listMultiComponent: {
          ...(state.listMultiComponent || {}),
          [dataId]: {
            currentSearch: dragCode ||
              currentState.get(
                ConstCommon.listComponent.Ownership,
                'currentSearch',
                dataId,
              ) || {
                code: 'AAA',
                displayCode: 'AAA',
              },

            indexSumary: {},
            indexSumaryRealTime: {},
            companyScore: {},

            boardOfDirectors: [],
            listBoardOfDirectorId: [],
            listBoardOfDirectorById: {},

            majorShareHolder: [],
            listMajorShareHolderId: [],
            listMajorShareHolderById: {},

            overViewChartData: [],
            majorOwnerShipChartData: [],

            bodTooltipInfo: {},
            shareHolderTooltipInfo: {},

            listBoardOfDirectors: {},
            listMajorShareHolders: {},
          },
        },
      };

    case UNMOUNT_COMPONENT:
      const delId = action.payload.id;
      const cloneListComponent = { ...state.listMultiComponent };
      const { [delId]: _, ...withoutDeleteKey } = cloneListComponent;
      if (Object.keys(withoutDeleteKey).length === 0) {
        return {};
      }
      return {
        ...state,
        listMultiComponent: withoutDeleteKey,
      };

    case SUBSCRIBE_REALTIME_DATA_TICK:
      const { result: resultTick, id: updateTickId } = action.payload;
      if (resultTick) {
        return {
          ...state,
          listMultiComponent: {
            ...state.listMultiComponent,
            [updateTickId]: {
              ...state.listMultiComponent[updateTickId],
              indexSumaryRealTime: resultTick,
            },
          },
        };
      }
      return state;

    case GET_COMPANY_SCORE:
      const { companyScore, companyScroreId } = action.payload;
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [companyScroreId]: {
            ...state.listMultiComponent[companyScroreId],
            companyScore,
          },
        },
        //companyScore
      };

    case FETCH_LIST_DATA_OWNERSHIP:
      const { response, componentId } = action.payload;
      let listBoardOfDirectorById = {};
      let listBoardOfDirectorId = [];
      let listMajorShareHolderById = {};
      let listMajorShareHolderId = [];
      let overViewChartData = [];
      let majorOwnerShipChartData = [];

      if (response.items) {
        [listBoardOfDirectorById, listBoardOfDirectorId] = appendId(
          response.items[0].boardOfDirectors,
        );
        [listMajorShareHolderById, listMajorShareHolderId] = appendId(
          response.items[0].majorShareHolders,
        );
        overViewChartData = response.items[0].overviewChartData;
        majorOwnerShipChartData = response.items[0].majorOwnershipsChartData;
      }

      if (!state.listMultiComponent || !state.listMultiComponent[componentId]) {
        return state;
      }

      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [componentId]: {
            ...state.listMultiComponent[componentId],
            listBoardOfDirectorById,
            listBoardOfDirectorId,
            listMajorShareHolderById,
            listMajorShareHolderId,
            overViewChartData,
            majorOwnerShipChartData,
            listBoardOfDirectors: response.items[0].boardOfDirectors,
            listMajorShareHolders: response.items[0].majorShareHolders,
          },
        },
      };

    case FETCH_BOD_TOOLTIP:
      const { bodTooltipInfo, infoBodTooltipId, personId } = action.payload;
      const key = `${action.payload.code}_${personId}`;
      const items = bodTooltipInfo.items.map(item => ({
        ...item,
        index: Math.random()
          .toString(36)
          .substring(2, 15), // unique key to map data tooltip
      }));
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [infoBodTooltipId]: {
            ...state.listMultiComponent[infoBodTooltipId],
            bodTooltipInfo: {
              ...state.listMultiComponent[infoBodTooltipId].bodTooltipInfo,
              [key]: items,
            },
          },
        },
      };

    case FETCH_SHARE_HOLDER_TOOLTIP: {
      const {
        shareHolderTooltipInfo,
        infoShareHolderTooltipId,
        code,
        listOrganizationByOrganCode,
      } = action.payload;

      const { items } = shareHolderTooltipInfo;

      const arrayDataTooltip = [];
      items.forEach(item => {
        const organization = listOrganizationByOrganCode[item.organCode];

        arrayDataTooltip.push({
          ...item,
          displayCode: organization ? organization.displayCode : item.organCode,
          nameAndExchange: organization
            ? transformExchangeTicker(
                organization.codeName,
                organization.exchange,
              )
            : '',
        });
      });

      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [infoShareHolderTooltipId]: {
            ...state.listMultiComponent[infoShareHolderTooltipId],
            shareHolderTooltipInfo: {
              ...state.listMultiComponent[infoShareHolderTooltipId]
                .shareHolderTooltipInfo,
              [code]: arrayDataTooltip,
            },
          },
        },
      };
    }

    case FETCH_INFO_TICKER:
      const { infoTicker, inforTickerId } = action.payload;
      let indexSumary = {};
      if (Object.keys(infoTicker).length) {
        indexSumary = infoTicker.priceInfo || {};
      }
      return {
        ...state,
        listMultiComponent: {
          ...state.listMultiComponent,
          [inforTickerId]: {
            ...state.listMultiComponent[inforTickerId],
            indexSumary: { ...indexSumary },
          },
        },
      };

    case CHANGE_CODE:
      const { conditionId, currentSearch } = action.payload;

      currentState.add(
        ConstCommon.listComponent.Ownership,
        'currentSearch',
        { code: currentSearch.code, displayCode: currentSearch.displayCode },
        conditionId,
      );

      const clone = {
        ...state.listMultiComponent,
        [conditionId]: {
          ...state.listMultiComponent[conditionId],
          currentSearch,
        },
      };

      return {
        ...state,
        listMultiComponent: clone,
      };

    default:
      return state;
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);
